export let DuplexerEvent = /*#__PURE__*/function (DuplexerEvent) {
  DuplexerEvent["AnalyzePageCompleted"] = "analyze_page_completed";
  DuplexerEvent["AnalyzePageFailed"] = "analyze_page_failed";
  DuplexerEvent["AnalyzeSiteLevelCompleted"] = "analyze_site_level_completed";
  DuplexerEvent["AnalyzeSiteLevelFailed"] = "analyze_site_level_failed";
  DuplexerEvent["AnalyzeJobCompleted"] = "analyze_job_completed";
  DuplexerEvent["AnalyzeJobFailed"] = "analyze_job_failed";
  return DuplexerEvent;
}({});
//# sourceMappingURL=types.js.map